import { render, staticRenderFns } from "./AwardItem.vue?vue&type=template&id=7238cece&scoped=true"
import script from "./AwardItem.vue?vue&type=script&lang=js"
export * from "./AwardItem.vue?vue&type=script&lang=js"
import style0 from "./AwardItem.vue?vue&type=style&index=0&id=7238cece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238cece",
  null
  
)

export default component.exports